/**
 * @Author: wuyang
 * @Date: 2024/1/10
 * @Description: ""
 */
import { FC, PropsWithChildren, ReactNode, useState,useContext } from 'react'
import type { UploadProps } from 'antd'
import { message, Progress, Upload } from 'antd'
import {
	BASE_URL,
	UPLOAD_MAX_HEIGHT,
	UPLOAD_MAX_RATIO,
	UPLOAD_MAX_SIZE,
	UPLOAD_MAX_WIDTH,
	UPLOAD_MIN_HEIGHT,
	UPLOAD_MIN_WIDTH,
	UPLOAD_FORMAT,
	UPLOAD_SERVER_MAX_SIZE
} from '@/constant'
import { userinfoService } from '@/common/services/userinfo/userinfoService'
import { createStore } from '@/helper/store/createStore'
import { ContextNav } from '@/layout/base/taskNavStory'

const { Dragger } = Upload

export interface IUploadPropsResponse {
	code: number
	data: { url: string }
	msg: string
}
export interface IDraggerUploadProps {
	beforeUpload?: (params: {
		width: number
		height: number
		ratio: number
	}) => boolean
	onUpload?: (data: IUploadPropsResponse['data']) => void
	renderChild?: () => ReactNode
	imgSize?:  number
}

export const DraggerUpload: FC<PropsWithChildren<IDraggerUploadProps>> = (
	props,
	context
) => {
	const [isUploading, setUploading] = useState(false)
	const [percent, setPercent] = useState(0)
	const [messageApi, contextHolder] = message.useMessage()

	const { onUpload, beforeUpload,imgSize } = props

	const upTsakType:any=useContext(ContextNav);
	const { taskType,setTasktype,taskGreat,setTaskGreat } = upTsakType || {};


	const uploadProps: UploadProps<IUploadPropsResponse> = {
		disabled: isUploading,
		name: 'file',
		accept: 'image/*',
		multiple: false,
		action: BASE_URL + '/oss/file/fileUploadWithMaxSize',
		headers: {
			Authorization: 'Bearer ' + userinfoService.token.get()
		},
		data: {
			maxSize: taskType == 5 ? 9999 : UPLOAD_SERVER_MAX_SIZE,
			// maxSize: taskType == 5 ? imgSize : UPLOAD_SERVER_MAX_SIZE,
			//这里需要添加一个type_task参数，用来区分上传的是哪种任务的图片 需求3
			type_task:1
		},
		showUploadList: false,
		beforeUpload(file) {
			setTaskGreat(true)
      console.log('上传之前修改了taskGreat')
			const { size, type } = file
			let img = new Image();
			console.log(img);

			img.onload =function(){
				console.log(img.width, img.height)
			}
			if (size > UPLOAD_MAX_SIZE) {
				messageApi.warning(
					`任务图片最大不能超过${Math.fround(UPLOAD_MAX_SIZE / 1024 / 1024)}M`
				)

				return false
			}
			console.log(file);

			/* if (!isLt2M) {
				message.error('Image must smaller than 2MB!');
			  } */
			// 获取文件格式 不在UPLOAD_FORMAT中不可上传
			if (!UPLOAD_FORMAT.includes(type)) {
				messageApi.warning(
					`请上传 ${UPLOAD_FORMAT.map((v) => v.replace('image/', '')).join('/')} 格式的图片`
				)
				return false
			}

			// 获取文件尺寸，判断尺寸在不在规定范围之内
			return new Promise(function (resolve, reject) {
				let reader = new FileReader()
				reader.readAsDataURL(file)
				reader.onload = function (theFile) {
					let image = new Image()
					image.src = theFile.target?.result as string
					image.onload = function () {
						const { width = 1, height = 1 } = image
						const r = width > height ? width / height : height / width
						// 如果有自定义上传事件，那么就判断自定义上传事件，否则走默认事件
						if (typeof beforeUpload === 'function') {
							const res = beforeUpload({ width, height, ratio: r })
							if (res) {
								setUploading(true)
								resolve(file)
							} else {
								setUploading(false)
								setPercent(0)
								reject()
							}
						} else {
							if (width < UPLOAD_MIN_WIDTH && height < UPLOAD_MIN_HEIGHT) {
								messageApi.warning(
									`任务图片最低分辨率为 ${UPLOAD_MIN_WIDTH} * ${UPLOAD_MIN_HEIGHT}`
								)
								setUploading(false)
								setPercent(0)
								reject()
							} else if (
								( width > UPLOAD_MAX_WIDTH || height > UPLOAD_MAX_HEIGHT ) && taskType != 5
							) {
								messageApi.warning(
									`任务图片尺寸最长边不超过 ${UPLOAD_MAX_WIDTH}`
								)
								setUploading(false)
								setPercent(0)
								reject()
							} else if (r > UPLOAD_MAX_RATIO) {
								messageApi.warning(`任务图片宽高比不超过 ${UPLOAD_MAX_RATIO}`)
								setUploading(false)
								setPercent(0)
								reject()
							} else {
								setUploading(true)
								resolve(file)
							}
						}
					}
				}
			})
		},
		onChange(info) {
			console.log(info, '----')
			const { status, percent } = info.file
			setPercent(percent ?? 0)
			if (status === 'uploading') {
				setPercent(percent ?? 0)
			} else {
				const { response, name } = info.file
				if (status === 'done' && response?.code === 200) {
					// messageApi.success(`${name} file uploaded successfully.`)
					onUpload?.(response.data)
				} else if (status === 'error') {
					messageApi.warning(`${name} 图片上传失败，请重新上传`)
				} else if (status === 'done' && response?.code === 500) {
					messageApi.warning(response.msg)
				}
				setUploading(false)
				setPercent(0)
			}
		},
		onDrop(e) {
			console.log('Dropped files', e.dataTransfer.files)
		}
	}

	if (typeof props.renderChild === 'function') {
		return (
			<Upload {...uploadProps}>
				{contextHolder}
				{props.renderChild()}
			</Upload>
		)
	}
	return (
		<>
			<Dragger {...uploadProps}>
				<div className={'relative'}>
					{isUploading ? (
						<div className={'flex justify-center items-center flex-col'}>
							<div>正在上传中...</div>
							<Progress percent={Math.floor(percent)} />
						</div>
					) : (
						<div>{props.children}</div>
					)}
				</div>
			</Dragger>
			{contextHolder}
		</>
	)
}
